// Backward compatibility: Export the new analytics system with the old interface
import GaGtag from '../analytics/legacy/GaGtag';

export default GaGtag;
